import React from 'react';
import cn from 'classnames';

var styles = {"optgroup":"select__optgroup_1xj36","label":"select__label_1xj36","l":"select__l_1xj36","xl":"select__xl_1xj36"};
require('./index.css');

var Optgroup = function (_a) {
    var children = _a.children, label = _a.label, _b = _a.size, size = _b === void 0 ? 's' : _b;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(styles.optgroup, styles[size]) },
            React.createElement("span", { className: styles.label }, label)),
        children));
};

export { Optgroup };
